import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Register Inertia side-load interceptor for client-side navigation hydration
import './plugins/sideload-interceptor';
